var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIdeal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-4.064 -4.064 164.952 143.597"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M112.393 7.558 87.467 5.467 3.726 4.207v128.855h89.388l29.787-8.101 20.277-17.577 9.918-27.648V47.794L138.264 22.13z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.37 6.37v122.727h74.565c45.026 0 69.52-20.974 69.52-61.52 0-41.669-26.55-61.208-69.52-61.208zM80.936 0c66.03 0 75.89 42.342 75.89 67.576 0 43.782-26.95 67.893-75.89 67.893H0V0z",
  style: {
    fill: "#0a0b09"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.373 48.549v13.848h4.25c2.946 0 5.666-.852 5.666-7.033 0-6.041-3.027-6.815-5.665-6.815zm70.906-6.888h6.876v20.736h10.189c-2.795-37.626-32.394-45.755-59.29-45.755H52.38v25.033h4.245c7.738 0 12.546 5.248 12.546 13.689 0 8.71-4.692 13.908-12.546 13.908h-4.245v50.09h28.676c43.729 0 58.947-20.308 59.484-50.09h-17.26zm-19.157 15.406h4.974l-2.274-7.805h-.413zM93.392 69.28l8.327-27.62h9.782l8.324 27.62h-7.158l-1.56-5.343h-8.994l-1.565 5.343zm-3.302-6.883v6.875H73.08V41.67h16.461v6.873h-9.584v3.2h9.064v6.87h-9.064v3.783z",
  style: {
    fill: "#d50172"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M43.375 55.46c0 8.194-6.64 14.837-14.834 14.837-8.19 0-14.836-6.643-14.836-14.837 0-8.188 6.646-14.834 14.836-14.834 8.195 0 14.834 6.646 14.834 14.834m-26.733 63.879h23.87V76.847h-23.87z"
})));
export default SvgIdeal;